export default __webpack_public_path__ + "static/media/training.b566d910.png";